import { Column } from 'farmhub-ui-core';

import AccountInformationItemSkeleton from 'components/Skeleton/AccountInformationItemSkeleton';
import { getFullAddress } from 'utils';

import AccountInformationItem from '../components/AccountInformationItem';
import HeaderElectronicBill from '../components/HeaderElectronicBill';
import OrderInformationOther from '../components/OrderInformationOther';
import OrderInformationSection from '../components/OrderInformationSection';
import { SettingBillSectionInformation } from '../components/SettingBillSection/interfaces';
import TitleElectronicBill from '../components/TitleElectronicBill';
import GroupProductTable from '../PaymentBillContent/components/GroupProductTable';
import { WaterMark } from './styles';

interface ContentToShowProps {
  order: any;
  setting: SettingBillSectionInformation;
  isLoading: boolean;
  isPrint?: boolean;
  isCart?: boolean;
}

const ContentToShow = ({
  order,
  setting,
  isLoading,
  isPrint = false,
  isCart = false,
}: ContentToShowProps): JSX.Element => (
  <WaterMark url={order?.supplier?.avatar}>
    <Column styles={{ zIndex: 1, position: 'relative', gap: 18 }}>
      {setting.visibleSupplier && (
        <HeaderElectronicBill
          data={order}
          isLoading={isLoading}
          isPrint={isPrint}
        />
      )}

      <TitleElectronicBill
        isCart={isCart}
        isLoading={isLoading}
        isPrint={isPrint}
        subTitle={`Mã ĐH: #${order.code}`}
        title="HÓA ĐƠN BÁN HÀNG"
      />
      {setting.visibleInformation && (
        <OrderInformationOther
          data={order}
          isCart={isCart}
          isLoading={isLoading}
          isPrint={isPrint}
        />
      )}
      {(setting.visibleCustomer || setting.visibleReceive) && (
        <OrderInformationSection
          isLoading={isLoading}
          isPrint={isPrint}
          title="Thông tin khách hàng"
        >
          {isLoading ? (
            <>
              <AccountInformationItemSkeleton />
              <AccountInformationItemSkeleton />
            </>
          ) : (
            <>
              {setting.visibleCustomer && (
                <AccountInformationItem
                  data={{
                    avatar: order.customer?.avatar,
                    name: order.customer?.displayName,
                    address: getFullAddress(
                      order.customer?.address,
                      order.customer?.ward?.district?.fullName,
                      order.customer?.ward?.province?.fullName,
                      order.customer?.ward?.fullName
                    ),
                    phoneNumber: order.customer?.phoneNumber,
                    role: 'Khách hàng',
                  }}
                  isPrint={isPrint}
                />
              )}
              {setting.visibleReceive && (
                <AccountInformationItem
                  data={{
                    avatar: order.customer?.avatar,
                    name: order.additionalInfo?.address?.title,
                    address: getFullAddress(
                      order.additionalInfo?.address?.address,
                      order.additionalInfo?.address?.district?.fullName,
                      order.additionalInfo?.address?.province?.fullName,
                      order.additionalInfo?.address?.ward?.fullName
                    ),
                    phoneNumber: order.additionalInfo?.address?.phoneNumber,
                    role: 'Người nhận',
                  }}
                  isPrint={isPrint}
                />
              )}
            </>
          )}
        </OrderInformationSection>
      )}
      <GroupProductTable isLoading={isLoading} order={order} />
    </Column>
  </WaterMark>
);

export default ContentToShow;
